import React, { Component, Fragment, useEffect, useRef, useState } from 'react';
// import Datas from '../../../data/course/item.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
// import { Container, Row, Col } from 'react-bootstrap';

import Pagination from '../../components/Pagination';
import DOMPurify from 'dompurify';
import { GetApi, PostApi } from '../../services/CommonService2';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Styles } from './styles/course.js';
import HeaderTwo from '../../components/HeaderTwo';
import StProgramSidebar from './components/StProgramSidebar.js';
import { prettyDOM } from '@testing-library/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginModal from '../../components/LoginModal.js';
import FooterTwo from '../../components/FooterTwo.js';
import Skeleton from 'react-loading-skeleton'
import backbutton from '../../politicalimgeas/back1.png'
import 'react-loading-skeleton/dist/skeleton.css'


const StuProgramGrid = () => {
    const didMountRef = useRef(false);
    const location = useLocation();

    const [allStPg, setAllStPg] = useState([])
    const [allStPg2, setAllStPg2] = useState([])
    const [allTypes, setAllTypes] = useState([])
    const [updatedTypes, setUpdatedTypes] = useState([])
    const [categorySelect, setCategorySelect] = useState([])
    const [totalRecords, setTotalRecords] = useState(null)
    const [searchKey, setSearchKey] = useState("")
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredTypes, setFilteredTypes] = useState([])
    const [modalUp, setModalUp] = useState(false)
    const [showError, setShowError] = useState(false)
    const history = useHistory();
    const [allSearch, setAllSearch] = useState(false)
    useEffect(() => {
        getData();
        console.log("location", location.state);

        localStorage.removeItem('previewtype');
    }, [])


    useEffect(() => {
        let arr = allTypes.map((item) => {
            return {
                ...item,
                check: false
            }
        })
        setUpdatedTypes(arr)

    }, [allTypes])



    const getData = async () => {
        // localStorage.removeItem('edutype');
        // localStorage.setItem('edutype', JSON.stringify('ITPROGRAMING'));
        localStorage.removeItem('edutype');
        localStorage.setItem('edutype', JSON.stringify('STUDENTPROGRAMMING'));

        const reqparam2 = {
            pageno: '-1',
            query: { status: 'Active', edutypeid: location.state.id }

            // query:{status:'Active',edutypeid :item.id,displayposition:'1'}
        }
        let categoriesResponse = await PostApi(reqparam2, 'INDIVIDUALEDUPROGRAM');
        setAllTypes(categoriesResponse.data)
    }

    useEffect(() => {
        var typesOnly = allTypes.map((item) => {
            return item.id
        })
        // console.log("allTypesallTypesallTypes",typesOnly);
        setFilteredTypes(typesOnly)

        const getPrograms = async () => {
            const reqparams = {
                pageno: 1,
                query: { status: 'Active' },
                optimize: true
            }
            reqparams.query.program = { $elemMatch: { "value": { $in: typesOnly } } };
            let response = await PostApi(reqparams, 'STUDENTPROGRAM');
            // console.log("all STUDENTPROGRAM",response?.data?.docs);
            setAllStPg(response?.data?.docs)
            setAllStPg2(response?.data)
            setTotalRecords(response?.data?.totalDocs)
            // console.log("total mate",response.data);
        }

        getPrograms()

    }, [allTypes])

    async function ctgSearch(e, data) {
        const { checked } = e.target

        if (checked) {
            setSearchKey("")

            if (categorySelect.length == 0) {
                setCategorySelect([data])
            }
            else {
                setCategorySelect((prevState) => {
                    return [...prevState, data]
                })
            }

        }
        else {
            setCategorySelect(categorySelect.filter((item) => item != data))
        }
    }

    useEffect(() => {

        if (didMountRef.current) {
            const categorySelectCheck = categorySelect.filter(t => t != null);
            const ctgbasedsearch = async () => {
                const reqparams3 = {
                    pageno: 1,
                    query: { status: 'Active' },
                    optimize: true
                }
                reqparams3.query.program = { $elemMatch: { "value": { $in: categorySelectCheck } } };
                let response = await PostApi(reqparams3, 'STUDENTPROGRAM');
                setAllStPg(response.data.docs)
                setTotalRecords(response.data.totalDocs)
                setCurrentPage(1)
                const updatedTypesWithCheck = updatedTypes.map((type) => ({
                    ...type,
                    check: categorySelect.some((categoryId) => categoryId === type.id),
                }));
                setUpdatedTypes(updatedTypesWithCheck)

            }

            if (categorySelectCheck.length != 0) {
                ctgbasedsearch()
            }
            else {
                if (searchKey == '') {
                    setAllStPg(allStPg2.docs)
                    setTotalRecords(allStPg2.totalDocs)

                    const updatedTypesWithCheck = updatedTypes.map((type) => ({
                        ...type,
                        check: false,
                    }));

                    setUpdatedTypes(updatedTypesWithCheck)
                }
            }
        }
        else {
            didMountRef.current = true;
        }
    }, [categorySelect])


    //search function

    const searchData = async (keySearch) => {

        setSearchKey(keySearch)

        // console.log("key", keySearch);

        const reqparams1 = {
            pageno: 1,
            query: { status: 'Active', name: { $regex: keySearch, $options: "i" } },
            optimize: true
        }
        reqparams1.query.program = { $elemMatch: { "value": { $in: filteredTypes } } };
        // reqparams1.query.name = { $regex: keySearch, $options: "i" }
        let response = await PostApi(reqparams1, 'STUDENTPROGRAM');
        // console.log("search dataa",response.data.docs);
        // console.log("search dataa total",response.data.total);
        if (response.data.totalDocs == 0) {
            setShowError(true)
        }
        else {
            setShowError(false)
        }
        setAllStPg(response.data.docs)
        setTotalRecords(response.data.totalDocs)
        setCategorySelect([])
        setCurrentPage(1)
        const updatedTypesWithCheck = updatedTypes.map((type) => ({
            ...type,
            check: false,
        }));

        setUpdatedTypes(updatedTypesWithCheck)


    }


    //useEffect when current page changes

    useEffect(() => {

        const setData = async () => {
            const reqparams1 = {
                pageno: currentPage,
                query: { status: 'Active' },
                optimize: true
            }
            // console.log("categorySelect value",categorySelect);
            if (categorySelect.length != 0) {
                reqparams1.query.program = { $elemMatch: { "value": { $in: categorySelect } } };
            }
            else if (searchKey != "") {
                reqparams1.query.name = { $regex: searchKey, $options: "i" }
            }

            const dataResponse2 = await PostApi(reqparams1, 'STUDENTPROGRAM'); //programs based on prog type 
            // console.log("All STUDENTPROGRAM page change", dataResponse2.data.docs);
            setAllStPg(dataResponse2.data.docs)
        }

        setData()

    }, [currentPage])

    const recordsPerPage = 10;
    const lastIndex = currentPage * recordsPerPage;
    const firstIndex = lastIndex - recordsPerPage;
    const npage = Math.ceil(totalRecords / recordsPerPage)
    const records = allStPg.slice(firstIndex, lastIndex)
    const numbers = [...Array(npage + 1).keys()].slice(1)


    const prePage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }


    }
    const changeCPage = (id) => {
        setCurrentPage(id)

    }
    const nextPage = () => {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)

        }

    }


    //login validate
    const loginValidate = (data) => {
        var tntId = JSON.parse(localStorage.getItem('tID'))

        const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
        if (userdata == null) {
            setModalUp(true)
            // e.preventDefault()

            toast.info('login to check course details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else {
            history.push({
                pathname: "/lmspage2",
                state: data
            })
        }
    }
    const openModal = () => {
        setModalUp(false)
    }

    const logIn = () => {

    }
    const [constituencySlider, setConstituencySlider] = useState("");


    useEffect(() => {
        getHomeBanners()
    }, [])

    const getHomeBanners = async () => {
        const reqparam = {
            pageno: '-1',
            query: { status: 'Active' }
        }

        const intoContentData = await GetApi(reqparam, "INTRO");
        setConstituencySlider(intoContentData.data)
    }
    const partnerPage = async () => {
        var tntId = JSON.parse(localStorage.getItem('tID'))

        const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
        if (userdata == null) {
            setModalUp(true)
            toast.info('login to check course details', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        else {
            history.push('/partner-onboard')
        }

    }

    const goBack = () => {
        history.goBack();
    };



    return (
        <div className="main-wrapper course-page">
            <button className="btn btn-warning" onClick={goBack} style={{ position: "fixed", bottom: "20px", left: "10px", zIndex: 999 }}><i class="fa-solid fa-arrow-left"></i></button>

            <HeaderTwo />
            {constituencySlider.length != 0 && <div id="carouselExampleIndicators" class="carousel slide " data-bs-ride="carousel" onClick={partnerPage}>
                <div class="carousel-inner mt-2" style={{ cursor: "pointer" }}>
                    {constituencySlider?.map((ele, ind) => {
                        if (ind == 0) {
                            return (
                                <div className={ind == 0 ? "carousel-item active " : "carousel-item"} >
                                    <img src={ele.webicon} className="d-block" alt="..." />
                                </div>
                            )
                        }

                    })}

                </div>
            </div>
            }

            <Styles>
                <section className="course-list-area">
                    <Container>
                        <div class="course-heading d-flex align-items-center justify-content-center py-3">
                            {/* <a href="#"> <img src={backbutton} className='videologo'></img></a> */}
                            <div class="content m-auto">
                                <h1 class="fs-3 fw-bold text-decoration-underline text-secondary ">{location?.state?.name}</h1>
                            </div>
                        </div>
                        <div class="filter">
                            <StProgramSidebar types={updatedTypes} ctgFn={ctgSearch}
                                dispAllPg={""} searchData={searchData}
                            />
                        </div>
                        {/* <Row>
                            <Col lg="12" md="3" sm="2">

                            </Col>

                        </Row> */}
                        <Row>
                            {/* {console.log("all st prog bruv",allStPg)} */}

                            <Col lg="12" md="12" sm="7">
                                <div className="course-items2">
                                    <Row>
                                        <Fragment>


                                            {
                                                allStPg?.map((data, i) => {

                                                    let imageid = 'https://visualpathedu.com/static/media/4th-year.15b862d606512e3257c0.jpg';
                                                    if (data?.image) {
                                                        imageid = data.image;
                                                    } else if (data?.image_url) {
                                                        imageid = data.image_url;
                                                    }
                                                    else if (data?.imageurl) {
                                                        imageid = data.imageurl ? data.imageurl : "";
                                                    }


                                                    return <Col md="3 d-flex justify-content-center py-3" key={i}>

                                                        <div className="card h-100" onClick={() => loginValidate(data)}>
                                                            <img src={imageid} className="card-img-top" ></img>

                                                            <div className="course-content  d-flex flex-column flex-grow-1">
                                                                <h6 className="heading">{data.name}</h6>
                                                                <div className="rating">
                                                                    <ul className="list-unstyled list-inline">
                                                                        {data?.duration && <p className='duration2' ><i class="fa-regular fa-clock projects-icon"></i>duration:{data?.duration}</p>}
                                                                    </ul>
                                                                </div>
                                                                <p className="desc2">{data.description?.slice(0, 100)}</p>
                                                                <div class="mt-auto">
                                                                    <button className="details-btn  btn-warning w-100" >View More</button>
                                                                </div>
                                                            </div>

                                                        </div>



                                                    </Col>
                                                })
                                            }

                                            {showError && <Skeleton height={180} count={4} />}

                                            {/* <Pagination /> */}

                                            {!showError && <Col md="12" className="text-center">
                                                <div className='mainpagination py-3 d-flex justify-content-center border-1 rounded-4 my-2'>
                                                    <ul className='pagination'>
                                                        <li className='page-item'>
                                                            <label className=' btn btn-outline-success page-link' onClick={prePage}><i class="fa-solid fa-angles-left"></i></label>

                                                        </li>
                                                        {numbers.map((n, i) => (
                                                            <li className={`page-item ${currentPage === n ? 'active' : ""}`} key={i}>
                                                                <label className='btn btn-outline-success page-link' onClick={() => changeCPage(n)}>{n}</label>

                                                            </li>

                                                        ))}

                                                        <li className='page-item'>
                                                            <label className='btn btn-outline-success page-link' onClick={nextPage}><i class="fa-solid fa-angles-right"></i></label>

                                                        </li>


                                                    </ul>
                                                </div>


                                            </Col>}

                                            {/* <Col md="12" className="text-center">
                                                <Pagination />
                                            </Col> */}

                                        </Fragment>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    {modalUp && <LoginModal onClose={openModal} login={logIn}></LoginModal>}
                </section>
            </Styles>

            {/* Footer 2 */}
            <FooterTwo />



        </div>
    )

}
export default StuProgramGrid


